var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashInventory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M73 48h89M73 96h89M30 144h78"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C71B8",
    d: "M156.5 172c13.531 0 24.5-10.969 24.5-24.5S170.031 123 156.5 123 132 133.969 132 147.5s10.969 24.5 24.5 24.5Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M157 134v4m0 19v4m-.5 11c13.531 0 24.5-10.969 24.5-24.5S170.031 123 156.5 123 132 133.969 132 147.5s10.969 24.5 24.5 24.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M150.125 157h9.563c1.408 0 2.76-.5 3.756-1.391S165 153.51 165 152.25c0-1.26-.56-2.468-1.556-3.359s-2.348-1.391-3.756-1.391h-6.376c-1.408 0-2.76-.5-3.756-1.391S148 144.01 148 142.75c0-1.26.56-2.468 1.556-3.359s2.348-1.391 3.756-1.391h9.563M51 42 35.667 57 28 49.5M51 88l-15.333 15L28 95.5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashInventory);
export default __webpack_public_path__ + "static/media/CashInventory.98772243847c0f6d84827438173d5bc1.svg";
export { ForwardRef as ReactComponent };